export const SAVE_TAB_IDX = 0
export const PRESENTATION_TAB_IDX = 1
export const METADATA_TAB_IDX = 2
export type TabIdxType =
  | typeof SAVE_TAB_IDX
  | typeof PRESENTATION_TAB_IDX
  | typeof METADATA_TAB_IDX
